import React, { useEffect } from "react";
import ReactGA from "react-ga";

import { shopId } from "config/const";
import { useAuth } from "providers/Auth";

export default function WithTracker({ children, ga }) {
  const { auth } = useAuth();
  const lineId = auth.userId;

  useEffect(() => {
    if (!lineId || !ga) return;
    const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
    ReactGA.set({
      userId: `shop/${shopId}/user/${lineId}`,
      referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
      title: ga,
    });
    ReactGA.pageview(page);
  }, [lineId, ga]);

  return <>{children}</>;
}
